<template>
  <modal v-model="value.show">
    <div slot="content">
      <div class="ls-modal-header">
        <button close-modal data-dismiss="modal">&times;</button>
        <h4 class="ls-modal-title">{{ $t('invoices.modal_confirm.title') }}</h4>
      </div>
      <div class="ls-modal-body">
        <div v-html="$t('invoices.modal_confirm.info')"></div>
      </div>
      <div class="ls-modal-footer">
        <button class="ls-btn" close-modal data-dismiss="modal">{{ $t('application.button.close') }}</button>
        <button type="submit" class="ls-btn ls-float-right" @click.prevent="sendInvoiceConfirmation()">{{ $t('invoices.modal_confirm.confirm') }}</button>
      </div>
    </div>
  </modal>
</template>
<script>
  import Modal from 'src/app/components/shareds/modal/Modal'
  import { mapActions } from 'vuex'

  export default {
    props: ['value'],
    components: { Modal },
    methods: {
      ...mapActions(['confirmInvoice']),
      sendInvoiceConfirmation () {
        this.value.show = false
        this.$loader.show()
        var params = { invoice_id: this.$parent.invoiceId }
        this.confirmInvoice(params).then(this.$parent.getInvoice)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalManualConfirmation.vue?2c13a405